import { useParams } from "react-router-dom";
import { EntityNotFound } from "features/layouts";
import { ReviewableTemplate, useArtist } from "features/reviewable";

// FOR EXAMPLE:
//   http://localhost:3001/artists/alba-m-torregrossa
//   http://localhost:3001/artists/riska-holakanola

function ArtistDetails() {
  const { artistId } = useParams() as { artistId: string };
  const query = useArtist(artistId);

  const notFound = (
    <EntityNotFound type="artist" linkText="Explore" linkTo="/search">
      You can find more artists on the Explore page, try searching or applying
      filters to find what you&apos;re looking for.
    </EntityNotFound>
  );

  return <ReviewableTemplate {...query} notFound={notFound} />;
}

export default ArtistDetails;
